<template>
    <div class="section-selector" :class="{ '-disabled': section.disabled }">
        <DatePicker
            @input="dateSelected"
            :value="value"
            :type="type"
            :border="false"
        />
    </div>
</template>
<script>
export default {
    props: {
        value: [Number, String, Object, Array],
        placeholder: String,
        massEdit: Boolean,
        loading: Boolean,
        format: String,
        section: Object,
        disabled: Boolean
    },
    computed: {
        type() {
            return this.section.scope ? this.section.scope : 'single'
        },
        initDate() {
            return {
                start: this.value
                    ? this.$moment(this.value)._d
                    : this.$moment()._d
            }
        },
        display() {
            let format = this.format ? this.format : 'YYYY-MM-DD'
            return {
                display: this.value
                    ? this.$moment(this.value).format(format)
                    : this.$t('LABEL_EMPTY')
            }
        }
    },
    methods: {
        dateSelected(date) {
            this.$emit('input', date)
        },
        toggleBody() {
            if (this.section.disabled || this.disabled) {
                return
            }
            this.$emit('click')
            this.$refs.datePicker.toggleCalendar()
        }
    }
}
</script>
<style lang="scss" scoped>
.sidebar-button {
    border: none;
}
</style>
